import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Paper } from '@material-ui/core';
import { noop } from 'lodash';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';

import { ContentInput } from 'api';
import { hasPhoto, hasVideo } from 'features/content/helpers';

import MediaUpload from '../ImageVideo/MediaUpload';
import MediaPreview from '../ImageVideo/MediaPreview';

interface IProps {
  onImageUpload?: () => void;
}

const useStyles = makeStyles(theme => ({
  paperDefault: {
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  paper: {
    minHeight: 175,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: theme.spacing(),
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
  },
}));

const ImageUpload: FC<IProps> = ({ onImageUpload }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext<ContentInput>();

  const hasContent = hasVideo(values) || hasPhoto(values);

  function onClickRemove() {
    setFieldValue('content_object.media', null);
    setFieldValue('content_object.photos', null);
  }

  return (
    <Paper
      variant="outlined"
      className={classNames(classes.paperDefault, { [classes.paper]: !hasContent })}>
      {hasContent ? <MediaPreview /> : <MediaUpload onImageUpload={onImageUpload} />}
      {hasContent && (
        <IconButton onClick={onClickRemove} className={classes.removeButton}>
          <CloseIcon />
        </IconButton>
      )}
    </Paper>
  );
};

ImageUpload.defaultProps = {
  onImageUpload: noop,
};

export default ImageUpload;
